import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Container,
  Row,
  Col,
  Table,
  Form,
  Spinner,
  Card,
} from 'react-bootstrap';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const TimeLogButton = () => {
  const role = localStorage.getItem('role');
  const hospitalId = localStorage.getItem('hospitalId');
  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user?.id;

  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    name: '',
    subHospital: '',
    date: '',
  });

  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      try {
        let response;
        if (role === 'admin') {
          response = await axios.get(`${BASE_URL}/api/hospital/admin`, {
            params: { hospital_id: hospitalId },
          });
        } else if (role === 'doctor' || role === 'receptionist') {
          response = await axios.get(`${BASE_URL}/api/hospital/user`, {
            params: { user_id: userId },
          });
        } else {
          setLogs([]);
          setLoading(false);
          return;
        }
        setLogs(response.data);
      } catch {
        setLogs([]);
      }
      setLoading(false);
    };
    fetchLogs();
  }, [role, hospitalId, userId]);

  const handleFilterChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const filteredLogs = logs.filter((log) => {
    const nameMatch =
      role === 'admin'
        ? log.name?.toLowerCase().includes(filters.name.toLowerCase())
        : true;
    const subHospitalMatch =
      role === 'admin'
        ? log.sub_hospital_name?.toLowerCase().includes(filters.subHospital.toLowerCase())
        : true;
    const dateValue =
      log.login_date ||
      log.activity_date ||
      (log.login_time && log.login_time.split('T')[0]) ||
      '';
    const dateMatch = dateValue.includes(filters.date);
    return nameMatch && subHospitalMatch && dateMatch;
  });

  const getTableHeaders = () => (
    <tr>
      {role === 'admin' && (
        <>
          <th>Name</th>
          <th>Sub-Hospital</th>
        </>
      )}
      <th>Date</th>
      <th>Total Time Spent</th>
      <th>Login Time</th>
    </tr>
  );

  const getTableRow = (log, idx) => (
    <tr key={idx}>
      {role === 'admin' && (
        <>
          <td>{log.name}</td>
          <td>{log.sub_hospital_name}</td>
        </>
      )}
      <td>
        {log.login_date ||
          log.activity_date ||
          (log.login_time && log.login_time.split('T')[0])}
      </td>
      <td>{log.total_time_spent || log.total_seconds || '-'}</td>
      <td>
        {log.login_time
          ? log.login_time.split('T')[1]?.slice(0, 8) || log.login_time
          : '-'}
      </td>
    </tr>
  );

  return (
    <Container fluid className="min-vh-100 px-0">
      <Row className="justify-content-center g-0">
        <Col xs={12} className="p-0">
          <Card className="shadow-sm rounded-4 w-100 border-0">
            <Card.Body>
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
                {/* Use your custom color or variable for heading */}
                <h2 className="global-heading mb-3 mb-md-0 fw-bold" style={{ color: "var(--primary-color)" }}>
                  Staff Time Logs
                </h2>
                <Form className="d-flex flex-wrap gap-2">
                  {role === 'admin' && (
                    <>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Filter by Name"
                        value={filters.name}
                        onChange={handleFilterChange}
                        className="w-auto"
                        size="sm"
                      />
                      <Form.Control
                        type="text"
                        name="subHospital"
                        placeholder="Filter by Sub-Hospital"
                        value={filters.subHospital}
                        onChange={handleFilterChange}
                        className="w-auto"
                        size="sm"
                      />
                    </>
                  )}
                  <Form.Control
                    type="date"
                    name="date"
                    placeholder="Filter by Date"
                    value={filters.date}
                    onChange={handleFilterChange}
                    className="w-auto"
                    size="sm"
                  />
                </Form>
              </div>
              <div className="table-responsive">
                <Table
                  striped
                  bordered
                  hover
                  className="AdminTable-root align-middle mb-0"
                  responsive
                >
                  <thead className="table-light">{getTableHeaders()}</thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={role === 'admin' ? 5 : 3} className="text-center">
                          <Spinner animation="border" size="sm" className="me-2" /> Fetching logs...
                        </td>
                      </tr>
                    ) : filteredLogs.length === 0 ? (
                      <tr>
                        <td colSpan={role === 'admin' ? 5 : 3} className="text-center text-muted">
                          No logs found for the selected criteria.
                        </td>
                      </tr>
                    ) : (
                      filteredLogs.map(getTableRow)
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TimeLogButton;